
const Logotipo = () => {
    return process.env.REACT_APP_API_ENDPOINT + "anexos/logo-" + window.location.host.split(':')[0].split('.')[0] + ".png";
}

const LogotipoBlack = () => {
    return process.env.REACT_APP_API_ENDPOINT + "anexos/logo-black-" + window.location.host.split(':')[0].split('.')[0] + ".png";
}

const LogoMarca = () => {
    return process.env.REACT_APP_API_ENDPOINT + "anexos/logo-secondary-" + window.location.host.split(':')[0].split('.')[0] + ".png";
}

export { 
    Logotipo, 
    LogotipoBlack, 
    LogoMarca 
};